import { Container } from "@mui/material";
import { Link } from "react-router-dom";
import User from "../../User";

function App() {
  User.logout();

  return (
    <Container className="center">
      <div>
        <h2>ログアウトしました</h2>
        <div className="text-center">
          <Link to="/login">ログイン画面へ</Link>
        </div>
      </div>
    </Container>
  );
}

export default App;
